import {Component, OnDestroy, OnInit} from '@angular/core';
import {TemporaryDashboard} from '../../../models/temporary-dashboard.model';
import {SubmitType} from '../../../../shared/models/submit.type';
import {NbDialogRef} from '@nebular/theme';
import {Subscription} from 'rxjs';
import {DashboardFacade} from '../../../facade/dashboard.facade';

@Component({
    selector: 'tart-save-dashboard-confirmation',
    templateUrl: './save-dashboard-confirmation.component.html',
    styleUrls: ['./save-dashboard-confirmation.component.scss'],
})
export class SaveDashboardConfirmationComponent implements OnInit, OnDestroy {
    title: string;
    message: string;
    temporaryDashboard: TemporaryDashboard;
    shouldDeleteTemporaryDashboard: boolean;
    dashboardName: string;
    viewMode: boolean;
    submitState: SubmitType;
    subscription: Subscription;

    constructor(private dialogRef: NbDialogRef<any>,
                private dashboardFacade: DashboardFacade) {
    }

    ngOnInit(): void {
        this.subscription = this.dashboardFacade.getSubmitState$().subscribe(submitType => {
            this.submitState = submitType;
            if (submitType === 'submitted') {
                this.dashboardFacade.setSubmitState('notSubmitted');
                this.closeDialog('deleteTempDashboard');
            }
            if (submitType === 'submitWithNoAction') {
                this.dashboardFacade.setSubmitState('notSubmitted');
                this.closeDialog('noAction');
            }
        });

        this.message = this.shouldDeleteTemporaryDashboard ?
            `داشبورد “${this.dashboardName}” تغییرات ذخیره‌نشده دارد.آیا این تغییرات قبل از خروج از ویرایش ذخیره شود؟` :
            `آیا از ذخیره تغییرات داشبورد “${this.dashboardName}” اطمینان دارید؟`;


    }

    saveDashboard(): void {
        const submitType: SubmitType = this.shouldDeleteTemporaryDashboard ? 'submitted' : 'submitWithNoAction';
        this.dashboardFacade.saveDashboard(this.temporaryDashboard, submitType);
    }

    closeDialog(state: 'deleteTempDashboard' | 'noAction'): void {
        this.dialogRef.close(state);
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
